import { partials } from '@shopify/partial-rendering';

// <abr-sku-colors> shows the other in-stock colours of a model on the product page.
// It requests the 'abr-sku-colors' partial from the search route with q=<SKU model code>; templates/search.liquid
// filters results by SKU prefix and stock server-side. The element stays hidden unless 2+ colours exist.
class AbrSkuColors extends HTMLElement {
  #started = false;

  connectedCallback() {
    if (this.#started) return;
    this.#started = true;
    this.#load();
  }

  async #load() {
    const model = (this.dataset.model || '').trim();
    if (!model || !this.dataset.search) return;
    const url = new URL(this.dataset.search, location.origin);
    url.searchParams.set('q', model);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    // Unavailable products are included; stock is checked per variant in the template.
    url.searchParams.set('options[unavailable_products]', 'show');

    const countOf = () => Number(this.querySelector('[data-abr-sku-count]')?.textContent || 0);
    const serverCount = countOf();
    const serverList = this.querySelector('[data-abr-sku-list]')?.innerHTML ?? '';

    try {
      const html = await partials.fetch('abr-sku-colors', { url: url.toString() });
      partials.apply(html);
      // Keep the server-rendered list when the catalog search found fewer colours (e.g. search unavailable).
      if (countOf() < serverCount) {
        const list = this.querySelector('[data-abr-sku-list]');
        const counter = this.querySelector('[data-abr-sku-count]');
        if (list) list.innerHTML = serverList;
        if (counter) counter.textContent = String(serverCount);
      }
      const count = countOf();
      for (const link of this.querySelectorAll('[data-product-id]')) {
        if (link.dataset.productId === this.dataset.current) link.setAttribute('aria-current', 'page');
      }
      this.hidden = count <= 1;
    } catch (error) {
      console.warn('ABR colour list could not load:', error);
    }
  }
}

if (!customElements.get('abr-sku-colors')) customElements.define('abr-sku-colors', AbrSkuColors);
